import { useRef } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'

import { useLenis } from '@/contexts/lenis'
import { useMotionTouchMedia } from '@/hooks'

import { getScrollTriggerOptions } from './shared'

export const useBeforeAfterMotion = () => {
  const motionRef = useRef<HTMLDivElement>(null)
  const scrollTrigger = useRef<ScrollTrigger>(null!)
  const { lenis } = useLenis()

  /**
   * reveal setup
   */
  useMotionTouchMedia(
    {
      pointer() {
        if (!lenis) return

        scrollTrigger.current = ScrollTrigger.create({
          ...getScrollTriggerOptions({
            trigger: motionRef.current,
            animation: gsap.from('[data-motion-block]', {
              opacity: 0,
              duration: 1,
              ease: 'power3.inOut'
            })
          })
        })
      },

      revert() {
        scrollTrigger.current?.kill()
      }
    },
    { scope: motionRef, dependencies: [lenis] }
  )

  return { motionRef }
}
